$('.home-gallery-otr').slick({
  dots: false,
  infinite: false,
  speed: 300,
  arrows: false,
  autoplaySpeed: 2000, // Adjust speed
    prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0986/7726/files/Group_1171283583.png?v=1728299032" ></div>',
    nextArrow: '<div class="slick-next"><img src=""></div>',
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});





$('.image-slider-otr').slick({
  dots: true,
  infinite: false,
  speed: 300,
  arrows: false,
  autoplaySpeed: 2000, // Adjust speed
    prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0986/7726/files/Group_1171283583.png?v=1728299032" ></div>',
    nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0986/7726/files/Group_1171283583.png?v=1728299032"></div>',
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});